import React, { useEffect, useState } from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { authService } from '../../services/api';
import '../../styles/AdminLayout.css';

const mainNav = [
    { to: '/admin', label: 'Visão geral', icon: 'ri-dashboard-line', end: true },
    { to: '/admin/news', label: 'Notícias', icon: 'ri-newspaper-line' },
    { to: '/admin/guides', label: 'Guias do jogo', icon: 'ri-book-open-line' },
    { to: '/admin/mount-guide', label: 'Guia de montarias', icon: 'ri-dragon-line' },
    { to: '/admin/downloads', label: 'Downloads', icon: 'ri-download-cloud-line' },
    { to: '/admin/event-packages', label: 'Pacotes de evento', icon: 'ri-gift-2-line' },
    { to: '/admin/streamers', label: 'Streamers / Lives', icon: 'ri-live-line' },
];

const settingsNav = [
    { to: '/admin/settings/general', label: 'Informações gerais' },
    { to: '/admin/settings/links', label: 'Links e Discord' },
    { to: '/admin/settings/navbar', label: 'Navbar e menu' },
    { to: '/admin/settings/home', label: 'Home e cards' },
    { to: '/admin/settings/download', label: 'Página de download' },
    { to: '/admin/settings/theme', label: 'Cores e tema' },
    { to: '/admin/settings/guildRank', label: 'Cards de guild' },
];

const AdminLayout: React.FC = () => {
    const navigate = useNavigate();
    const [accessChecked, setAccessChecked] = useState(false);

    useEffect(() => {
        const verify = async () => {
            if (!authService.isAuthenticated()) {
                navigate('/login');
                return;
            }
            const isAdmin = await authService.checkIsAdmin();
            if (!isAdmin) {
                navigate('/');
                return;
            }
            setAccessChecked(true);
        };
        verify();
    }, [navigate]);

    if (!accessChecked) {
        return (
            <div className="admin-shell">
                <main className="admin-main">
                    <div className="admin-page">
                        <p className="admin-page-subtitle">Verificando permissões...</p>
                    </div>
                </main>
            </div>
        );
    }

    return (
        <div className="admin-shell">
            <aside className="admin-sidebar">
                <div className="admin-sidebar-brand">PAINEL ADMIN</div>

                <nav className="admin-sidebar-nav">
                    {mainNav.map(item => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            end={item.end}
                            className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}
                        >
                            <i className={item.icon} aria-hidden />
                            {item.label}
                        </NavLink>
                    ))}

                    <div className="admin-nav-group-label">Site e aparência</div>
                    {settingsNav.map(item => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            className={({ isActive }) => `admin-nav-item admin-nav-sub ${isActive ? 'active' : ''}`}
                        >
                            {item.label}
                        </NavLink>
                    ))}
                </nav>

                <Link to="/" className="admin-back-link">
                    <i className="ri-arrow-left-line" aria-hidden />
                    Voltar ao site
                </Link>
            </aside>

            <main className="admin-main">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
